var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1558_11647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 38.636C30.2927 38.636 38.6365 30.2922 38.6365 19.9996C38.6365 9.70707 30.2927 1.36328 20.0001 1.36328C9.70755 1.36328 1.36377 9.70707 1.36377 19.9996C1.36377 30.2922 9.70755 38.636 20.0001 38.636Z",
    fill: "#FFEDEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C8.97273 40 0 31.0273 0 20C0 8.97273 8.97273 0 20 0C31.0273 0 40 8.97273 40 20C40 31.0273 31.0273 40 20 40ZM20 2.72727C10.4773 2.72727 2.72727 10.4773 2.72727 20C2.72727 29.5227 10.4773 37.2727 20 37.2727C29.5227 37.2727 37.2727 29.5227 37.2727 20C37.2727 10.4773 29.5227 2.72727 20 2.72727Z",
    fill: "#C8051E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 29.0856C21.004 29.0856 21.818 28.2716 21.818 27.2674C21.818 26.2632 21.004 25.4492 19.9998 25.4492C18.9957 25.4492 18.1816 26.2632 18.1816 27.2674C18.1816 28.2716 18.9957 29.0856 19.9998 29.0856Z",
    fill: "#C8051E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 22.2718C19.2453 22.2718 18.6362 21.6627 18.6362 20.9082V12.2718C18.6362 11.5173 19.2453 10.9082 19.9999 10.9082C20.7544 10.9082 21.3635 11.5173 21.3635 12.2718V20.9082C21.3635 21.6627 20.7544 22.2718 19.9999 22.2718Z",
    fill: "#C8051E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1558_11647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.871076b1eb07a6995c0bc8e369c2abfd.svg";
export { ForwardRef as ReactComponent };